module.exports = __webpack_public_path__ + "img/icon_nav_home.7553eba7.svg";